import { render, staticRenderFns } from "./AnexosOcorrencia.vue?vue&type=template&id=b652310c"
import script from "./AnexosOcorrencia.vue?vue&type=script&lang=js"
export * from "./AnexosOcorrencia.vue?vue&type=script&lang=js"
import style0 from "./AnexosOcorrencia.vue?vue&type=style&index=0&id=b652310c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports